import { TextVariantType } from '../variants';
export const commonStyles = (FOUNDATIONS, FONT) => ({
    link: {
        font_variant: TextVariantType.LINK_FONT_PARAGRAPH_350,
        color: FOUNDATIONS.color_comp_navigation_breadcrumbs_default_font,
    },
    iconDivider: {
        color: FOUNDATIONS.color_comp_navigation_breadcrumbs_default_icon,
        width: FOUNDATIONS.size_75,
        height: FOUNDATIONS.size_125,
    },
    iconDividerContainer: {
        margin_left: FOUNDATIONS.spacing_100,
        margin_right: FOUNDATIONS.spacing_100,
    },
    lastOneCrumb: {
        color: FOUNDATIONS.color_comp_navigation_breadcrumbs_currentpage_font,
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
    },
});
//# sourceMappingURL=commonStyles.js.map